import Swiper from "swiper";
import "swiper/css";
import { Navigation } from "swiper/modules";
import productCardClickService from "../services/ProductCardClickService";
import eshopHeaderService from "../header/EshopHeaderService";
import subheaderPromoBannerService from "../services/SubheaderPromoBannerService";
import elementService from "@/common/ElementService";

export default class EshopHomePageService {
    private static readonly Second = 1000;
    private static readonly Minute = this.Second * 60;
    private static readonly Hour = this.Minute * 60;
    private static readonly Day = this.Hour * 24;

    private readonly promoCountdown: HTMLSpanElement;
    private readonly showCategoriesMenuButton: HTMLAnchorElement;
    private benefitsSwiper?: Swiper;

    constructor() {
        this.promoCountdown = elementService.querySelector<HTMLSpanElement>("#js-promo-countdown");
        this.showCategoriesMenuButton = elementService.querySelector<HTMLAnchorElement>("#js-homepage-show-categories-menu");
    }

    public init(): void {
        this.runPromoCountDown();
        this.initShowAllCategoriesButton();
        this.initSlickerForBenefits();
        productCardClickService.initForContainer(elementService.querySelector<HTMLDivElement>("#content"));
        subheaderPromoBannerService.init();
    }

    private runPromoCountDown(): void {
        const konec = new Date();
        konec.setHours(23, 59, 59, 999);
        const timeDiff = konec.getTime() - Date.now();

        if (timeDiff < EshopHomePageService.Second) {
            this.promoCountdown.innerHTML = "";

            return;
        }

        const hours = Math.floor(timeDiff % EshopHomePageService.Day / EshopHomePageService.Hour);
        const minutes = Math.floor(timeDiff % EshopHomePageService.Hour / EshopHomePageService.Minute);
        const seconds = Math.floor(timeDiff % EshopHomePageService.Minute / EshopHomePageService.Second);

        this.promoCountdown.innerHTML = `${hours.toString()}:${this.padDigits(minutes)}:${this.padDigits(seconds)}`;
        setTimeout(() => this.runPromoCountDown(), EshopHomePageService.Second);
    }

    private initShowAllCategoriesButton(): void {
        this.showCategoriesMenuButton.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();
            eshopHeaderService.toggleCategoriesMenu();
        });
    }

    private initSlickerForBenefits(): void {
        const container = elementService.querySelector<HTMLDivElement>("#benefits2");

        const createSwiper = (): void => {
            if (this.benefitsSwiper) {
                return;
            }

            container.classList.add("swiper");

            // vytvořit wrapper, pokud neexistuje, a přesunout children do něj jako swiper-slide
            let wrapper = container.querySelector<HTMLDivElement>(".swiper-wrapper");

            if (!wrapper) {
                wrapper = document.createElement("div");
                wrapper.className = "swiper-wrapper";

                // Přesun všech současných prvků do wrapperu
                while (container.firstChild) {
                    const child = container.firstChild as HTMLElement;
                    child.classList.add("swiper-slide");
                    wrapper.appendChild(child);
                }

                container.appendChild(wrapper);
            } else {
                for (const c of wrapper.children) {
                    (c as HTMLElement).classList.add("swiper-slide");
                }
            }

            // navigační tlačítka pouze pokud neexistují
            if (!container.querySelector<HTMLButtonElement>(".home_page_item_slider_control_left")) {
                container.insertAdjacentHTML("afterbegin", `
                    <button class="home_page_item_slider_control_left home_page_item_slider_control_button"><i class="fa-solid fa-caret-left"></i></button>
                `);
            }

            if (!container.querySelector<HTMLButtonElement>(".home_page_item_slider_control_right")) {
                container.insertAdjacentHTML("beforeend", `
                    <button class="home_page_item_slider_control_right home_page_item_slider_control_button"><i class="fa-solid fa-caret-right"></i></button>
                `);
            }

            try {
                this.benefitsSwiper = new Swiper(container, {
                    modules: [Navigation],
                    slidesPerView: 1,
                    loop: false,
                    navigation: {
                        nextEl: ".home_page_item_slider_control_right",
                        prevEl: ".home_page_item_slider_control_left",
                    },
                    breakpoints: {
                        768: { slidesPerView: 3 },
                    },
                });
            } catch (error) {
                if (!(error instanceof TypeError)) {
                    throw error;
                }
                // v případě TypeError nic nedělat
            }
        };

        // const destroySwiper = (): void => {
        //     if (this.benefitsSwiper) {
        //         try {
        //             this.benefitsSwiper.destroy(true, true);
        //         } catch {
        //             // ignorovat chyby při destroy
        //         }
        //
        //         this.benefitsSwiper = undefined;
        //     }
        //
        //     // odstranit navigační tlačítka
        //     const left = container.querySelector<HTMLButtonElement>(".home_page_item_slider_control_left");
        //     const right = container.querySelector<HTMLButtonElement>(".home_page_item_slider_control_right");
        //
        //     if (left) {
        //         left.remove();
        //     }
        //
        //     if (right) {
        //         right.remove();
        //     }
        //
        //     // // přesunout slidey z wrapperu zpět a odstranit třídy
        //     // const wrapper = container.querySelector<HTMLDivElement>(".swiper-wrapper");
        //     //
        //     // if (wrapper) {
        //     //     while (wrapper.firstChild) {
        //     //         const child = wrapper.firstChild as HTMLElement;
        //     //         child.classList.remove("swiper-slide");
        //     //         container.appendChild(child);
        //     //     }
        //     //
        //     //     wrapper.remove();
        //     // }
        //     //
        //     // container.classList.remove("swiper");
        // };

        createSwiper();

        // const mq = window.matchMedia("(max-width: 768px)");
        //
        // // inicialně podle aktuální šířky
        // if (mq.matches) {
        //     createSwiper();
        // } else {
        //     destroySwiper();
        // }
        //
        // // reagovat na změny velikosti
        // const handler = (event: MediaQueryListEvent): void => {
        //     if (event.matches) {
        //         createSwiper();
        //     } else {
        //         destroySwiper();
        //     }
        // };
        //
        // if (typeof mq.addEventListener === "function") {
        //     mq.addEventListener("change", handler);
        // }
    }

    private padDigits(value: number): string {
        const stringValue = value.toString();

        return stringValue.length === 1 ? `0${stringValue}` : stringValue;
    }
}
